// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.full-height {\n  position: relative;\n  height: 100%;\n}\n.iconSize {\n  font-size: 14px;\n}\n", ""]);
// Exports
module.exports = exports;
